import { VgApiResult, vgApiRequest } from "./vg-api.service";

export type OrgPhoneNumber = {
  phoneNumberId: number;
  orgId: number;
  phoneNumber: string;
  phoneNumberType: number; // 1=Mobile, 2=Home, 3=Work
};

type PhoneNumbersResponse = {
  phoneNumberList?: Array<Record<string, unknown>>;
};

function pickPhoneNumber(item: Record<string, unknown>): OrgPhoneNumber {
  return {
    phoneNumberId: Number(item.phoneNumberId ?? item.PhoneNumberId ?? 0),
    orgId: Number(item.orgId ?? item.OrgId ?? 0),
    phoneNumber: String(item.phoneNumber ?? item.PhoneNumber ?? ""),
    phoneNumberType: Number(item.phoneNumberType ?? item.PhoneNumberType ?? 0),
  };
}

export const PHONE_TYPE_LABELS: Record<number, string> = {
  1: "Mobile",
  2: "Home",
  3: "Work",
};

export async function readOrgPhoneNumbers(
  accessToken: string,
  orgId: number
): Promise<VgApiResult<OrgPhoneNumber[]>> {
  const { data, error } = await vgApiRequest<PhoneNumbersResponse>(
    accessToken,
    "Read_All_Org_PhoneNumbers_By_Org_ID",
    { orgId }
  );
  if (error) return { data: null, error };
  const list = data?.phoneNumberList ?? [];
  return { data: list.map(pickPhoneNumber), error: null };
}
